import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Moment from 'moment';

import { FaClipboardList } from 'react-icons/fa';
import { IoIosInformationCircle } from 'react-icons/io';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';
import { FaLocationArrow } from 'react-icons/fa';
import { MdLocationCity } from 'react-icons/md';
import { FaShoppingCart } from 'react-icons/fa';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { FaReceipt } from 'react-icons/fa';
import { FaDatabase } from 'react-icons/fa';
import { FaAngleDoubleDown } from 'react-icons/fa';

import api from '~/services/api';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Grid,
  GridHeadItem,
  GridLine,
  GridItem,
} from '~/components';

import { Info, Block, MyZone, OtherZone } from './styles';

import PedidoType from '~/@types/pedido';
import PedidoERPType from '~/@types/pedidoerp';

import { ParamsProps } from './interface';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const Venda: React.FC = () => {
  const { id } = useParams<ParamsProps>();

  const [inLoad, setInLoad] = useState(false);

  const [pedido, setPedido] = useState<PedidoType | null>(null);
  const [pedidoERP, setPedidoERP] = useState<PedidoERPType | null>(null);

  useEffect(() => {
    const fetchPedido = async (cId: string) => {
      try {
        setInLoad(true);

        const response = await api.get(`pedido/${cId}`);

        const { data } = response;

        if (data) {
          setPedido(data);
        }
        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    const fetchPedidoERP = async (cId: string) => {
      try {
        setInLoad(true);

        const response = await api.get(`pedido-no-erp/${cId}`);

        const { data } = response;

        if (data) {
          setPedidoERP(data);
        }
        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    fetchPedido(id);
    fetchPedidoERP(id);
  }, [id]);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            back="/pedidos"
            title="Detalhes da pedido"
            subtitle="Veja os detalhes da pedido"
          />

          <MyZone>
            <Block>
              <h1>
                <i>
                  <FaClipboardList size={22} color="#333" />
                </i>
                <span>INFORMAÇÕES GERAIS</span>
              </h1>
              <Grid>
                <GridLine>
                  <GridItem width={200}>IDPEDIDO</GridItem>
                  <GridItem>
                    <strong>{pedido?.idpedido}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>TIDERP</GridItem>
                  <GridItem>
                    <strong>{pedido?.tiderp}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>STATUS</GridItem>
                  <GridItem>
                    <span   
                      style={{
                        backgroundColor: pedido?.statuscor,
                        color: '#fff',
                        padding: 5,
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                      }}
                    >
                      {pedido?.status}
                    </span>
                  </GridItem>
                </GridLine>

                <GridLine>
                  <GridItem width={200}>CANAL</GridItem>
                  <GridItem>
                    {pedido?.iconecanal ? (
                      <img src={pedido?.iconecanal} alt={pedido?.canal} />
                    ) : null}
                    <br />
                    <strong>{pedido?.canal}</strong>
                    <br />
                    <small>Conta: {pedido?.conta}</small>
                  </GridItem>
                </GridLine>
              </Grid>

              {pedido?.outrasinfos && pedido?.outrasinfos !== '' ? (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>{pedido?.outrasinfos}</p>
                </div>
              ) : null}
            </Block>

            <Block>
              <h1>
                <i>
                  <FaCalendarAlt size={22} color="#333" />
                </i>
                <span>TIMELINE</span>
              </h1>
              <Grid>
                <GridLine>
                  <GridItem width={200}>DATA DO PEDIDO</GridItem>
                  <GridItem>
                    <strong>{pedido?.dt}</strong>
                    <br />
                    <small>
                      {Moment(pedido?.dt, 'DD/MM/YYYY HH:mm').fromNow()}
                    </small>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>LIBERAÇÃO DO ENVIO</GridItem>
                  <GridItem>
                    <strong>{pedido?.dtliberaenvio}</strong>
                    <br />
                    <small>
                      {Moment(
                        pedido?.dtlimiteenvio,
                        'DD/MM/YYYY HH:mm',
                      ).toNow()}
                    </small>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>LIMITE DE ENVIO</GridItem>
                  <GridItem>
                    <strong>{pedido?.dtlimiteenvio}</strong>
                    <br />
                    <small>
                      {Moment(
                        pedido?.dtlimiteenvio,
                        'DD/MM/YYYY HH:mm',
                      ).toNow()}
                    </small>
                  </GridItem>
                </GridLine>
                {pedido?.dtentrega ? (
                  <GridLine>
                    <GridItem width={200}>DATA DE ENTREGA</GridItem>
                    <GridItem>
                      <strong>{pedido?.dtentrega}</strong>
                      <br />
                      <small>
                        {Moment(pedido?.dtentrega, 'DD/MM/YYYY HH:mm').toNow()}
                      </small>
                    </GridItem>
                  </GridLine>
                ) : null}
              </Grid>
            </Block>

            {pedido?.cliente.tipo === '1' ? (
              <Block>
                <h1>
                  <i>
                    <FaUser size={22} color="#333" />
                  </i>
                  <span>CLIENTE</span>
                </h1>

                <Grid>
                  <GridLine>
                    <GridItem width={200}>NOME</GridItem>
                    <GridItem>
                      <strong>
                        {pedido?.cliente.nome} {pedido?.cliente.sobrenome}
                      </strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>CPF</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.cpf}</strong>
                    </GridItem>
                  </GridLine>
                  {pedido?.cliente.email ? (
                    <GridLine>
                      <GridItem width={200}>E-MAIL</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.email}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.sexo ? (
                    <GridLine>
                      <GridItem width={200}>SEXO</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.sexo}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.dtnascimento ? (
                    <GridLine>
                      <GridItem width={200}>DATA DE NASCIMENTO</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.dtnascimento}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.telefone ? (
                    <GridLine>
                      <GridItem width={200}>TELEFONE</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.telefone}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                </Grid>
              </Block>
            ) : null}

            {pedido?.cliente.tipo === '2' ? (
              <Block>
                <h1>
                  <i>
                    <MdLocationCity size={22} color="#333" />
                  </i>
                  <span>EMPRESA</span>
                </h1>

                <Grid>
                  <GridLine>
                    <GridItem width={200}>RAZÃO SOCIAL</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.razaosocial}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>FANTASIA</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.nomefantasia}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>CNPJ</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.cnpj}</strong>
                    </GridItem>
                  </GridLine>
                  {pedido?.cliente.email ? (
                    <GridLine>
                      <GridItem width={200}>E-MAIL</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.email}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.telefone ? (
                    <GridLine>
                      <GridItem width={200}>TELEFONE</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.telefone}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                </Grid>
              </Block>
            ) : null}

            <Block>
              <h1>
                <i>
                  <FaLocationArrow size={22} color="#333" />
                </i>
                <span>ENDEREÇO</span>
              </h1>
              <Grid>
                <GridLine>
                  <GridItem width={200}>LOGRADOURO</GridItem>
                  <GridItem>
                    <strong>{pedido?.endereco.logradouro}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>NÚMERO</GridItem>
                  <GridItem>
                    <strong>{pedido?.endereco.numero}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>BAIRRO</GridItem>
                  <GridItem>
                    <strong>{pedido?.endereco.bairro}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>CIDADE</GridItem>
                  <GridItem>
                    <strong>{pedido?.endereco.cidade}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>UF</GridItem>
                  <GridItem>
                    <strong>{pedido?.endereco.uf}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>CEP</GridItem>
                  <GridItem>
                    <strong>{pedido?.endereco.cep}</strong>
                  </GridItem>
                </GridLine>
              </Grid>

              {pedido?.endereco.complemento &&
              pedido?.endereco.complemento !== '' ? (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>{pedido?.endereco.complemento}</p>
                </div>
              ) : null}
            </Block>

            <Block>
              <h1>
                <i>
                  <FaShoppingCart size={22} color="#333" />
                </i>
                <span>ITENS</span>
              </h1>

              {pedido?.itens.length ? (
                <>
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="NOME" />
                      <GridHeadItem title="SKU" width={100} />
                      <GridHeadItem title="QUANTIDADE" width={80} />
                      <GridHeadItem title="UNITÁRIO" width={200} />
                    </GridLine>

                    {pedido.itens.map((item, idx) => (
                      <GridLine>
                        <GridItem>{item.descricao}</GridItem>
                        <GridItem width={100}>{item.sku}</GridItem>
                        <GridItem width={80}>{item.qtd}</GridItem>
                        <GridItem width={200}>
                          {item.precounitformatado}
                        </GridItem>
                      </GridLine>
                    ))}
                  </Grid>
                </>
              ) : (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>Nenhum item associado ao pedido</p>
                </div>
              )}
            </Block>

            <Block>
              <h1>
                <i>
                  <FaFileInvoiceDollar size={22} color="#333" />
                </i>
                <span>INFORMAÇÕES FINANCEIRAS</span>
              </h1>

              <Grid>
                <GridLine>
                  <GridItem>
                    <div className="finance-r" style={{ color: "#1ca3e2" }}>SUB-TOTAL</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong style={{ color: "#1ca3e2" }}>{pedido?.precoprodutosformatado}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r" style={{ color: "#e2441c" }}>DESCONTO</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong style={{ color: "#e2441c" }}>-{pedido?.precodescontoformatado}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r" style={{ color: "#7e43dd" }}>FRETE</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong style={{ color: "#7e43dd" }}>{pedido?.precofreteformatado}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r" style={{ color: "#797709" }}>TAXAS</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong style={{ color: "#797709" }}>{pedido?.precotaxas}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r" style={{ color: "#137913" }}>TOTAL</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong style={{ color: "#137913" }}>{pedido?.precototalformatado}</strong>
                  </GridItem>
                </GridLine>
              </Grid>
            </Block>

            <Block>
              <h1>
                <i>
                  <FaReceipt size={22} color="#333" />
                </i>
                <span>FATURAMENTO</span>
              </h1>

              {pedido && pedido.numnfe ? (
                <Grid>
                  <GridLine>
                    <GridItem width={300}>NÚMERO DA NFE</GridItem>
                    <GridItem>{pedido.numnfe}</GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={300}>CHAVE DA NFE</GridItem>
                    <GridItem>{pedido.chavenfe}</GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={300}>SÉRIE DA NFE</GridItem>
                    <GridItem>{pedido.serienfe}</GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={300}>URL DO XML</GridItem>
                    <GridItem>{pedido.urlxmlnfe}</GridItem>
                  </GridLine>
                </Grid>
              ) : (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>Pedido ainda não foi faturado</p>
                </div>
              )}

              {pedido?.endereconfe.complemento &&
              pedido?.endereconfe.complemento !== '' ? (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>{pedido?.endereconfe.complemento}</p>
                </div>
              ) : null}
            </Block>
          </MyZone>
          <OtherZone>
            <Info>
              <div>
                <h1>TOTVS (ORACLE)</h1>
                <p>
                  Abaixo é possivel visualizar como as informações do pedido
                  foram sincronizadas dentro do banco de dados do seu ERP.
                </p>
                <FaAngleDoubleDown size={22} color="#333" />
              </div>
            </Info>

            <Block>
              <h1>
                <i>
                  <FaDatabase size={22} color="#333" />
                </i>
                <span>INFORMAÇÕES GERAIS</span>
              </h1>

              {pedidoERP && pedidoERP._pedido ? (
                <Grid>
                  {pedidoERP._pedido.map(item => (
                    <GridLine>
                      <GridItem width={300}>{item.prop}</GridItem>
                      <GridItem>{item.valor}</GridItem>
                    </GridLine>
                  ))}
                </Grid>
              ) : (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>Não encontramos informações do pedido</p>
                </div>
              )}
            </Block>

            {pedidoERP && pedidoERP._itens ? (
              <Block>
                <h1>
                  <i>
                    <FaDatabase size={22} color="#333" />
                  </i>
                  <span>ITENS</span>
                </h1>

                {pedidoERP._itens.length ? (
                  <>
                    {pedidoERP._itens.map((item, idx) => (
                      <main>
                        <h2>{idx + 1}</h2>
                        <Grid>
                          {item.map(item => (
                            <GridLine>
                              <GridItem width={200}>{item.prop}</GridItem>
                              <GridItem>{item.valor}</GridItem>
                            </GridLine>
                          ))}
                        </Grid>
                      </main>
                    ))}
                  </>
                ) : (
                  <div className="info">
                    <i>
                      <IoIosInformationCircle size={22} color="#333" />
                    </i>
                    <p>Nenhum item associado ao pedido</p>
                  </div>
                )}
              </Block>
            ) : null}

            {pedidoERP && pedidoERP._fpgs ? (
              <Block>
                <h1>
                  <i>
                    <FaDatabase size={22} color="#333" />
                  </i>
                  <span>FORMAS DE PAGAMENTO</span>
                </h1>

                {pedidoERP._fpgs.length ? (
                  <>
                    {pedidoERP._fpgs.map((item, idx) => (
                      <main>
                        <h2>{idx + 1}</h2>
                        <Grid>
                          {item.map(item => (
                            <GridLine>
                              <GridItem width={200}>{item.prop}</GridItem>
                              <GridItem>{item.valor}</GridItem>
                            </GridLine>
                          ))}
                        </Grid>
                      </main>
                    ))}
                  </>
                ) : (
                  <div className="info">
                    <i>
                      <IoIosInformationCircle size={22} color="#333" />
                    </i>
                    <p>Nenhuma forma de pagamento associada ao pedido</p>
                  </div>
                )}
              </Block>
            ) : null}

            <Block>
              <h1>
                <i>
                  <FaDatabase size={22} color="#333" />
                </i>
                <span>FATURAMENTO</span>
              </h1>

              {pedidoERP && pedidoERP._faturamento ? (
                <Grid>
                  {pedidoERP._faturamento.map(item => (
                    <GridLine>
                      <GridItem width={200}>{item.prop}</GridItem>
                      <GridItem>{item.valor}</GridItem>
                    </GridLine>
                  ))}
                </Grid>
              ) : (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color="#333" />
                  </i>
                  <p>Não encontramos informações de faturamento do pedido</p>
                </div>
              )}
            </Block>
          </OtherZone>
        </Container>
      </Scroll>
    </>
  );
};

export default Venda;
